// extracted by mini-css-extract-plugin
export default {"centerBlock":"mainStyle_centerBlock__vyaBF","custom-loader":"mainStyle_custom-loader__GjHG8"};